import React from "react";
/* This resets old fraction styles that don't allow the body to scroll */
export default ({ noScroll }) => (
  <style>
    {`
      body {
        overflow: ${noScroll ? "hidden" : "auto !important"};
      }
        body > #bookshelf {
          overflow: ${noScroll ? "hidden" : ""};
          height: auto;
          width: auto;
          position: relative;
          top: auto;
          bottom: auto;
          left: auto;
          right: auto;
          overflow: hidden;
        }
        ul {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        p {
          margin: 0;
        }
      }

      `}
  </style>
);
